import React from 'react';
import './ServiceAgreement.css';

const ServiceAgreement = ({ companyName = 'XXXXXXXXXXXXXXXX', companyAddress = 'XXXXXXXXXXXXXX'}) => {
  const currentDateObj = new Date();
  const currentDate = currentDateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const endDateObj = new Date(currentDateObj);
  endDateObj.setFullYear(endDateObj.getFullYear() + 5);
  const endDate = endDateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="service-agreement">
      <div className="section">
        <h1 className="centered bold underline">REFERRAL SERVICES AGREEMENT</h1>
      </div>

      <div className="section">
        <p>This Referral Services Agreement <strong>("Agreement")</strong> is made and executed at Mumbai on this {currentDate} ("Execution Date").</p>
      </div>

      <div className="section centered bold">
        <p>BY AND BETWEEN</p>
      </div>

      <div className="parties-section">
        <p><strong>Mywish Marketplaces Pvt. Ltd (hereinafter referred to as "MMPL")</strong>, a Company incorporated under the Companies Act, 1956 and having its Registered Office at Innov8, Ras Vilas, Lower Ground Floor Salcon Rasvilas, D-1 Saket District Center, New Delhi, Delhi, India – 110017 and Head Quartered at E32, E30, Sector 8 Noida, UP 201301, unless it be repugnant to the context or meaning thereof, be deemed to mean and include its successors-in-interest and permitted assigns) of the ONE PART;</p>

        <p className="centered bold">AND</p>

        <p><strong>{companyName}</strong>, a company incorporated under the Companies Act, 1956 and having its registered office at {companyAddress} (hereinafter referred to as "<strong>Service Provider</strong>" which expression unless repugnant to the mean or context thereof shall deem to include its successors and permitted assigns) of the SECOND PART;</p>

        <p>MMPL and Service Provider shall hereinafter be individually referred to as Party and collectively referred to as Parties</p>
      </div>

      <div className="section">
        <p>WHEREAS Mywish Marketplaces Pvt. Ltd is a company engaged in financial consulting and providing various financial services to its customers in India and provides one step solution for all types of loans and cards in India including personal loans, home loans, credit cards, education loans, car loans, loan against property etc.</p>

        <p>The SERVICE PROVIDER has represented and offered to the company that it has the necessary skill, experience, expertise and infrastructure to act as the Selling Associate of the company under the laws and regulations applicable to the DSA to market the Products and Services, within the Territory.</p>

        <p>The Parties have mutually agreed to work together wherein MMPL wishes to obtain certain Services from {companyName}, as defined under this Agreement on the terms and conditions as mentioned herein below.</p>
      </div>

      <div className="section bold">
        <p>NOW THEREFORE THIS AGREEMENT WITNESSETH AND IT IS HEREBY AGREED BY AND BETWEEN THE PARTIES HERETO AS UNDER:</p>
      </div>

      <div className="section">
        <h2>1. SCOPE OF SERVICES</h2>
        <p>The Company agrees to appoint the Service Provider to generate and provide leads for i.e. prospective customers having loan requirements for Financial Products including but not limited to Personal Loans, Credit Cards, Business Loan, Home Loan, Loan Against Property ('Products'). The Company agrees to provide offline fulfilment services to these customers for the markets agreed upon. ("Services").</p>
        
        <p>In this context, Service Provider will undertake marketing to generate potential customers. Service Provider will be responsible only for undertaking an initial verification process of the leads generated in order to check the veracity of the customer and thereafter pass the verified lead to MMPL.</p>
        
        <p>Once the lead is forwarded by the Service provider to the Company, the Company will have contact or interaction with the customer to understand their loan requirements and needs and shall be solely responsible towards arranging the Products i.e. sanction of loan, from one or multiple banks with whom they are empanelled and which is best suited to the needs of the customers. The Service Provider will be responsible for sharing all the documents required to process the Product application of the lead. Post transfer of leads and documents by Service Provider, The Company will be responsible for undertaking all the steps towards fulfilling the loan requirement of the customers for the aforesaid Products.</p>
        
        <p>Leads for potential customer shared to MMPL shall be under the joint ownership of the Company and the Service Provider.</p>
        
        <p>The Service Provider shall not have any power to enter into any contracts or agreements directly with the customers and its banking partners. Canvassing to the prospective customers shall be done on the terms and conditions which THE ONE PART stipulate from time to time.</p>
      </div>

      <div className="section">
        <h2>2. TERM & TERMINATION</h2>
        <p><strong>TERM:</strong> This Agreement shall be for a period of 5 (five) years commencing from {currentDate} ("Effective Date") and expiring on {endDate}, unless terminated in accordance with the terms and conditions mentioned under this Agreement. The Parties may renew this Agreement for such further period as mutually agreed in writing between the Parties.</p>
        
        <p><strong>TERMINATION:</strong> This Agreement can be terminated by either Party by giving 30 (thirty) days written notice to the other Party. Upon, termination MMPL shall make all outstanding payments to the Service Provider within seven (7) days from the date of termination of the Agreement subject to receipts of payment from respective banks. Without prejudice, the termination of this Agreement for any cause shall not release any Party from any liability/ claim, which at the time of termination has already accrued to the other Party or which thereafter may accrue in respect of any act or omission prior to such termination or which has accrued in consequence of this clause.</p>
      </div>

      <div className="section">
        <h2>3. ETHICS AND BUSINESS PRINCIPLES</h2>
        <p>SERVICE PROVIDER shall not engage in any deceptive, fraudulent, unlawful, illegal or unethical practice. SERVICE PROVIDER shall ensure that no statements, promises or testimonials are made which are likely to mislead customers OR effect the reputation of ONE PART. SERVICE PROVIDER shall truthfully identify themselves, their company, the products and services and the purposes of their solicitation to the prospective customer.</p>
        
        <p>SERVICE PROVIDER shall not be intrusive and shall respect the privacy of the customers. Contact (whether personal or by telephone or through online) with the customer.</p>
      </div>

      <div className="section">
        <h2>4. FEES, RECOVERY AND PAYMENTS</h2>
        <p>In consideration of the Services provided by the Service Provider, MMPL shall pay Referral fees per month to the Service Provider as per the tables below.</p>
          <table>
            <thead>
              <tr>
                <th>Product/Service</th>
                <th>Payout on disbursal amount on monthly basis (exclusive of Tax)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Personal Loan</td>
                <td></td>
              </tr>
              <tr>
                <td>Business Loan</td>
                <td></td>
              </tr>
              <tr>
                <td>Home Loan</td>
                <td></td>
              </tr>
              <tr>
                <td>LAP</td>
                <td></td>
              </tr>
              <tr>
                <td>Credit Card</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <p className="fee-note">Note: The above payout rates are indicative and subject to change as per bank policies.</p>
        <p>The payout of Referral fees shall be based on the gross disbursal of loan as sanctioned by the respective banks. The fees payable shall be exclusive of tax. Fees/Payouts will keep changing periodically (as banks change payouts, or create bonus payouts, or new products are launched), and the Service Provider will be able to access latest Payout for the month, at the beginning of the month, on the MMPL's Service Provider portal and/or through Email communication.</p>
        
        <p>The fees will be paid after deduction of applicable tax at source as per the prevalent Income Tax Act.</p>
        
        <p>The Service provider shall raise a monthly invoice in favour of the Company for the Services rendered by it to the Company in the preceding month. All Payments to the Service provider shall be made within 7 (seven) days of the company receiving the payments from the respective banks but in no case later than 30 (thirty) days from the date of invoice, subject to receipts of payment from respective banks. The Company shall share with Service Provider detailed report about the status on the leads, disbursal amounts and related MIS on first working day of every week.</p>
        
        <p>Any Penalty or fine charged by the Bank/NBFC for the cases/lead provided by Service provider will be recovered from Service provider through adjustment against his Payout.</p>
        
        <p>Monthly invoicing against previous month's Services will be completed / held upon receipt of confirmation and all the relevant documents as required, from the Parties for monthly reconciliation to avoid any dispute later on.</p>
      </div>

      <div className="section">
        <h2>5.SERVICE PROVIDER TO COMPLY WITH LAW AND INSTRUCTIONS</h2>
        <p>The Service Provider shall always act in conformity with all applicable laws, rules and regulations and all instructions, (general, specific or special) as and when provided to the by THE COMPANY. These instructions may be amended, added, modified or revised by THE COMPANY from time to time and shall be communicated to the Service Provider who shall comply with them. It shall be the responsibility of the Service provider to convey the instructions/ guidelines and the amendments, additions, modifications, revisions as the case may be to its employee, staff and personnel and ensure that they are strictly adhered to.</p>
      </div>

      <div className="section">
        <h2>6.INTELLECTUAL PROPERTY RIGHTS OF THE COMPANY</h2>
        <p>All intellectual property rights, including without limitation trademarks, trade name, service marks, logo, copyrights, advertising copy, material, graphics, software etc., will remain the sole property of THE COMPANY. On a case-to-case basis, THE COMPANY may, at its absolute discretion, permit the use of its name and logo on the business cards and other stationery materials used by the Service Provider. However, the usage of THE COMPANY’s name and logo shall be solely for the purposes described in this agreement and will be subject to express prior written approval of THE COMPANY and on the terms stipulated by THE COMPANY. It is specifically made clear to the Service Provider that such usage of the name and logo by the Service Provider shall not create any right, title or interest in respect of the name, logo or intellectual property in favour of the Service Provider.</p>
      </div>

      <div className="section">
        <h2>7.NON-EXCLUSIVITY</h2>
        <p>The Service Provider understands and hereby acknowledges that this Agreement entered into between THE COMPANY and the Service Provider does not provide any exclusive right to the Service Provider to get contract jobs from THE COMPANY and that THE COMPANY is free to engage as many Service Providers or agents, whether similar or otherwise, and enter into agreements with any other person/ firm/ company as may be deemed fit by THE COMPANY.</p>
      </div>

      <div className="section">
        <h2>8.INDEMNITY</h2>
        <p>The Service Provider shall indemnify THE COMPANY and keep THE COMPANY fully indemnified and harmless against any loss, claim, action, proceeding, damages, expense or cost that any customer or any other person whomsoever may make against THE COMPANY in respect of any breach, violation, act of omission or commission by the Service Provider or its employee(s), staff, personnel or representative(s) under this Agreement and/ or any instructions that may be given by THE COMPANY to Service Provider.</p>
      </div>

      <div className="section">
        <h2>9.CONFIDENTIALITY</h2>
        <p>Each party agrees to keep confidential the existence and terms of this Agreement as well as any other confidential information in relation to the Company that is disclosed and must ensure that their respective Personnel do likewise.</p>
      </div>

      <div className="section">
        <h2>11.NOTICE IN WRITING</h2>
        <p>Any notice by either party to the other party shall be in writing and delivered at the address of the other party given herein below.</p>
      </div>

      <div className="section">
        <p>Address of THE COMPANY:</p>
        <p><b>Mywish Marketplaces Pvt Ltd.</b></p>
        <p>E32, E30, Sector 8 Noida</p>
        <p>UP 201301</p>

        <p>Address of the Service Provider:</p>
        
      </div>

      <div className="section">
        <h2>12.ARBITRATION AND JURISDICTION</h2>
        <p>All disputes and / or claims and / or questions whatsoever which shall arise during the continuance of this Agreement or afterwards either between the parties hereto or their respective representatives touching these presents, or the construction or application thereof, or any clause or thing herein contained, or any account or liability between the parties hereto, or as to any act, deed or omission of any party hereto in any way relating to these presents, shall be referred to arbitration to be conducted in accordance with the rules of arbitration and conciliation of the Arbitration and Conciliation Act, 1996 or any law pertaining to domestic arbitration as prevailing and in force at the time of such dispute/claim or question. The proceedings of such arbitration shall be held at Delhi.</p>
        <p>All legal proceedings shall be subject to the exclusive jurisdiction of the Courts at Delhi.</p>
      </div>

      <div className="section">
        <h2>13.SEVERABILITY</h2>
        <p>The invalidity or unenforceability of any provisions of this Agreement in any jurisdiction shall not effect the validity, legality or enforceability of the remainder of this Agreement in such jurisdiction or the validity, legality or enforceability of this Agreement, including any such provision, in any other jurisdiction, it being intended that all rights and obligations of the Parties hereunder shall be enforceable to the fullest extent permitted by law.</p>
      </div>

      <div className="section">
        <h2>14.FORCE MAJEURE</h2>
        <p>Neither Party shall be liable for any loss or damage caused to the other Party, provided that the Party experiencing the delay promptly notifies the other of the delay, for its failure to perform any or all of its obligations under this Agreement during any period in which such performance is delayed or rendered impractical or impossible due to events which are beyond the reasonable control of the Parties such as Acts of God which include natural calamities, fire, pandemic/ epidemic, floods and droughts, wars, riots, insurrection, acts of the public enemy, terrorism (“Force Majeure Event/s”); provided, however, that in the event a Force Majeure Event persists for 60 (sixty) days or more, either Party shall have the right, but not the obligation, to terminate this Agreement.</p>
      </div>

      <div className="section">
        <h2>15.COUNTERPARTS</h2>
        <p>This Agreement may be entered into in 2 (two) or more counterparts each of which, when executed and delivered, shall be an original, but all the counterparts shall together constitute one and the same instrument.</p>
      </div>

      <div className="signature-section">
        <div className="signature-block">
          <div className="signature-title">
            <p>Signed for and on behalf of Mywish Marketplaces Pvt Ltd</p>
          </div>
          <div className="signature-space"></div>
          <div className="signature-info">
            <p>By:</p>
            <p>Title: Authorized Signatory- Director</p>
          </div>
        </div>
        
        <div className="signature-block">
          <div className="signature-title">
            <p>Signed for and on behalf of {companyName}</p>
          </div>
          <div className="signature-space"></div>
          <div className="signature-info">
            <p>By:</p>
            <p>Title: Authorized Signatory</p>
          </div>
        </div>
      </div>

      <div className="witness-section">
        <p><strong>IN WITNESS WHEREOF</strong>, the Parties hereto have executed this Agreement as of the day and year first set forth above.</p>
        <p>&nbsp;</p>
        <p>Witness by: -</p>
        <p>1. ____________________</p>
        <p>&nbsp;</p>
        <p>2. ____________________</p>
      </div>
    </div>
  );
};

export default ServiceAgreement;